/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum BundleOrTourType {
  Tour = 'tour',
  Bundle = 'bundle'
}
